import { render, staticRenderFns } from "./settingGeneral.vue?vue&type=template&id=325e7b6a&scoped=true"
import script from "./settingGeneral.vue?vue&type=script&lang=js"
export * from "./settingGeneral.vue?vue&type=script&lang=js"
import style0 from "./settingGeneral.vue?vue&type=style&index=0&id=325e7b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e7b6a",
  null
  
)

export default component.exports